<template>
  <BaseModalContent :name="name" :dynamic="true" @close="$emit('close')">
    <div>
      <div class="preview" v-if="platform">
        <div
          class="preview__cover-image mb-l"
          :style="imageStyle"
          v-if="platform.cover_url"
        />
        <h2 class="title">
          {{ platform.name || "Площадка с ID:" + platform.id }}
        </h2>

        <div class="preview__description-text-box" v-if="formattedDescription">
          <p class="subtitle">Описание</p>
          <div
            class="preview__description-text"
            :class="{ 'is-open': isOpen }"
            ref="overflowContent"
          >
            <div class="typography" v-html="formattedDescription" />
          </div>

          <a
            href="#"
            class="link link--pseudo"
            v-if="isOverflow"
            @click.prevent="isOpen = !isOpen"
            >{{ isOpen ? "скрыть" : "показать" }}</a
          >
        </div>

        <template v-if="showNavBlock">
          <p class="subtitle">Как добраться</p>
          <p class="mb-m" v-if="platform.navigation_link">
            Маршрут:
            <a
              :href="platform.navigation_link"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
              >{{ platform.navigation_link }}</a
            >
          </p>

          <div
            class="typography mb-m"
            v-if="formattedNavigation"
            v-html="formattedNavigation"
          />

          <img
            :src="platform.navigation_image_url"
            alt="Карта-схема"
            class="preview__image"
            v-if="platform.navigation_image_url"
          />
        </template>

        <div class="buttons">
          <BaseButton @click="onActionClick" v-if="!selectedPlatform"
            >Выбрать площадку</BaseButton
          >
          <BaseButton theme="secondary" @click="$emit('close')"
            >Закрыть</BaseButton
          >
        </div>
      </div>
    </div>
  </BaseModalContent>
</template>
<script>
import { platformsService } from "@/services/platforms";
const marked = require("marked");
export default {
  name: "VenueModal",
  props: {
    venue: Object,
  },
  data() {
    return {
      isOverflow: false,
      isOpen: false,
      platform: { ...this.venue },
    };
  },
  computed: {
    name() {
      return "venue-modal";
    },
    imageStyle() {
      const { cover_url } = this.platform;
      if (cover_url) {
        return {
          backgroundImage: `url(${cover_url})`,
        };
      }
      return null;
    },
    formattedDescription() {
      if (!this.platform?.description) return;
      return marked.parse(this.platform.description);
    },
    formattedNavigation() {
      if (!this.platform?.navigation_text) return;
      return marked.parse(this.platform.navigation_text);
    },
    showNavBlock() {
      return (
        this.formattedDescription ||
        this.formattedNavigation ||
        this.platform?.navigation_image
      );
    },
    selectedPlatform() {
      return this.$store.state.requestPreparing.selectedPlatform;
    },
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getPlatform();
      if (this.formattedDescription) {
        this.checkOverflow();
      }
    },
    checkOverflow() {
      const el = this.$refs.overflowContent;
      this.isOverflow = el.scrollHeight > el.offsetHeight;
    },
    onActionClick() {
      this.$store.commit(
        "requestPreparing/SET_SELECTED_PLATFORM",
        this.platform
      );
      this.$emit("close");
    },
    async getPlatform() {
      try {
        const { data } = await platformsService.getPlatformById(this.venue.id);
        if (data) {
          this.platform = data;
        }
      } catch (error) {
        console.log("error %O", error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@text-lh: 20/14;

.title {
  margin-bottom: 30px;
  font-size: @font-size-h2;
  line-height: @line-height-h2;
  font-weight: bold;
}
.subtitle {
  margin-bottom: 15px;
  font-weight: bold;
  font-size: @font-size-h3;
  line-height: @line-height-h3;
}
.preview {
  &__cover-image {
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 4px;

    &::before {
      content: "";
      display: block;
      aspect-ratio: (720 / 348);
    }
  }
  &__description {
    flex-shrink: 0;
    flex-basis: 260px;
    border: 1px solid @gray-color;
    border-radius: @border-radius-xs;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;

    &-title {
      font-weight: bold;
      font-size: 13px;
      line-height: (17 / 13);
      text-transform: uppercase;
      margin-bottom: 5px;
    }

    &-text {
      line-height: @text-lh;
      max-height: @text-lh * 6em;
      overflow: hidden;

      &.is-open {
        max-height: 600px;
        overflow: auto;
      }
    }

    &-text-box {
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
    &-text-url {
      word-break: break-word;
    }
  }
  &__image {
    max-width: 100%;
    max-height: 615px;
    object-fit: cover;
    object-position: center;
  }
}
.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
